"use client";

import { Box, Grid2, Select, Typography } from "@repo/ui";
import Section from "../components/Section";
import { useMemo, useState } from "react";
import StructuredData from "@/components/common/StructuredData";
import useConstantValueList from "@/hooks/useConstantValueList";
import CourseCard2 from "@/components/courses/CourseCard2";

type CoursesWithLevelFilterProps = {
  sectionInfo: PageSections;
  data: {
    coursesWithLevelFilter: ServiceByTypeInterface[];
  };
};

const CoursesWithLevelFilter = ({
  data,
  sectionInfo,
}: CoursesWithLevelFilterProps) => {
  const courseListSchema = useMemo(() => {
    return {
      "@context": "https://schema.org",
      "@type": "ItemList",
      itemListElement: data.coursesWithLevelFilter.map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        item: {
          "@type": "Course",
          url: `${process.env.NEXT_PUBLIC_APP_URL}/course/${item.slug}/`,
          name: item.name,
          description: item.description,
          provider: {
            "@type": "Organization",
            name: "Spoclearn",
            sameAs: process.env.NEXT_PUBLIC_APP_URL,
          },
        },
      })),
    };
  }, [data.coursesWithLevelFilter]);

  const { loading, data: serviceLabels } =
    useConstantValueList("SERVICES_LEVELS");
  const [filter, setFilter] = useState("240");
  return (
    <Section
      id={sectionInfo.sectionId}
      className={`${sectionInfo.sectionClass} !scroll-m-[66px]`}
    >
      {/* Filter label and Select filter */}
      <Box flex justifyContent="between" alignItems="center" className="mb-4">
        <Typography className="grow-0">{`All Courses (${
          data.coursesWithLevelFilter?.filter((item) =>
            filter === "240" ? true : item.serviceLevelId == filter
          ).length
        })`}</Typography>
        <div>
          {/* {!loading && serviceLabels.length > 0 && ( */}
          <Select
            options={serviceLabels}
            value={filter}
            defaultValue={filter}
            onChange={(val) => setFilter(val)}
            loading={loading}
            align="end"
            noLabel
            name="servicelabel"
          />
          {/* )} */}
        </div>
      </Box>
      <Grid2 container spacing={5}>
        {data.coursesWithLevelFilter
          ?.filter((item) =>
            filter === "240" ? true : item.serviceLevelId == filter
          )
          .map((item) => (
            <Grid2
              key={`categorized-course-${item.id}`}
              size={{ xs: 12, sm: 12, md: 4, lg: 4 }}
            >
              <CourseCard2
                serviceId={item.id}
                title={item.name}
                coverSrc={item.service_image}
                totalEnroll={item.numberOfLearners}
                duration={item.serviceTrainingDays}
                slug={item.slug}
                accreditation_name={item.accreditation_name}
                icon={item.serviceIcon}
                modeOfTraining={
                  item.mode_of_training || "Live Classroom / Classroom"
                }
                sellingPriceNumber={item.sellingPriceNumber}
                currency={item.currency}
              />
            </Grid2>
          ))}
      </Grid2>

      {/* Course list schema */}
      <StructuredData data={courseListSchema} />
    </Section>
  );
};

export default CoursesWithLevelFilter;
